import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

const store = createStore({
  state () {
    return {
      userInfo: {}  // 你的用户信息
    };
  },
  mutations: {
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo;
    }
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage,  // 或使用 sessionStorage
    })
  ]
});

export default store;
